import { PlatformCard } from '@/components/molecules/PlatformCard';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { Translation } from '@/lib/i18n';
import type { KnownPlatform } from '@/lib/platformTypes';
import { Plus } from 'lucide-react';

type Props = {
	platforms: KnownPlatform[];
	translation: Translation;
	onSelect: (subdomain: string) => void;
	onForget: (platform: KnownPlatform) => void;
	onUseAnother: () => void;
};

export function KnownPlatformsPage({ platforms, translation, onSelect, onForget, onUseAnother }: Props) {
	return (
		<Card
			className="relative w-full max-w-[33rem] border-0 bg-white/96 p-0 shadow-[0_1.5rem_4rem_rgba(23,48,42,.1)] max-sm:min-h-[calc(100svh-5.3rem)] max-sm:max-w-none max-sm:rounded-none max-sm:bg-white max-sm:shadow-none"
			aria-labelledby="choose-title"
		>
			<CardHeader className="items-center px-[clamp(1.5rem,4vw,3rem)] pt-[clamp(1.5rem,4vw,3rem)] pb-0 text-center">
				<CardTitle className="my-[.35rem] mb-[.8rem] text-[clamp(1.75rem,4vw,2.35rem)] font-[750] tracking-[-.045em] text-[#16221f]">
					<h1
						id="choose-title"
						className="m-0"
					>
						{translation.chooseTitle}
					</h1>
				</CardTitle>

				<CardDescription className="m-0 leading-relaxed text-[#687773]">
					{translation.chooseDescription}
				</CardDescription>
			</CardHeader>
			<CardContent className="px-[clamp(1.5rem,4vw,3rem)] pb-[clamp(1.5rem,4vw,3rem)]">
				<div className="my-8 grid gap-3">
					{platforms.map((platform) => (
						<PlatformCard
							key={platform.subdomain}
							platform={platform}
							forgetLabel={translation.forget}
							onSelect={onSelect}
							onForget={onForget}
						/>
					))}
				</div>

				<Button
					variant="ghost"
					className="mx-auto mt-1 flex text-primary hover:text-primary-hover active:text-primary-active [&_svg]:size-4"
					onClick={onUseAnother}
				>
					<Plus />
					{translation.another}
				</Button>
			</CardContent>
		</Card>
	);
}
